import { Component, Input } from "@angular/core";
import { BaseChartDirective } from "ng2-charts";
import { getSnapshotSummaryFromDaysAgo, SnapshotDailySummary } from "./user-collection-general-stats.component";
import { formatDate } from "@ponder-shared/utils/general";
import { environment } from "../../../../../environments/environment";
import { ChartBaseComponent, ChartDataLabelType } from "@ponder-shared/charts/chart-base.component";
import { FormatCurrencyPipe } from "@ponder-shared/pipes/format-currency.pipe";
import { isMobileScreen } from "@ponder-shared/utils/screenBreakpoints";
import { NgClass } from "@angular/common";

@Component({
    selector: "collection-snapshot-value-chart",
    imports: [NgClass, BaseChartDirective, FormatCurrencyPipe],
    templateUrl: "./collection-snapshot-value-chart.component.html"
})
export class CollectionSnapshotValueChartComponent extends ChartBaseComponent {
    @Input({ required: true }) public snapshotSummaries!: SnapshotDailySummary[];
    
    public changeValue1w: number = 0;
    public changeValue1m: number = 0;
    public changeValue1y: number = 0;
    public changeValueAll: number = 0;

    public override ngOnInit(): void {
        this.dataLabel = "Items";
        this.dataLabelType = ChartDataLabelType.Currency;
        this.xGridLineVisible = false;
        this.yGridLineVisible = false;
        this.yGridBorderVisible = false;
        this.xLabelColor = "#888";
        this.yLabelColor = "#888";
        this.lineWidth = 2;
        this.lineRadius = 2;
        this.lineColor = environment.colors.chart.green;
        this.fillArea = true;
        this.backgroundColor = environment.colors.chart.greenfade;

        super.ngOnInit();

        this.setDataGlances();
        this.updateData();
    }

    private updateData(): void {
        var labels: string[] = [];

        var min = Number.MAX_SAFE_INTEGER;
        var max = 0;
        
        var past = (this.snapshotSummaries.length < 3) ? 3 - this.snapshotSummaries.length : 0;
        
        if (past) {
            for (let i = past; i > 0; i--) {
                var date = new Date();
                date.setDate(this.snapshotSummaries[0].date.getDate() - (7 * i));

                labels.push(formatDate(date));
                this.addDataPoint(null);
            }
        }

        this.snapshotSummaries.forEach(s => {
            min = Math.min(min, s.value);
            max = Math.max(max, s.value);

            labels.push(formatDate(s.date));
            this.addDataPoint(s.value);
        });

        this.minYValue = Math.floor(min * 0.95);
        this.maxYValue = Math.ceil(max * 1.05);

        this.setSuggestedYScale();
        this.setLabels(labels);
    }
    
    public isMobileScreen(): boolean {
        return isMobileScreen();
    }

    private setDataGlances(): void {
        if (!this.snapshotSummaries.length) {
            return;
        }

        var now = (new Date()).getTime();

        var snapshotFirst = this.snapshotSummaries[0];
        var snapshot1y = getSnapshotSummaryFromDaysAgo(365, now, this.snapshotSummaries);
        var snapshot1m = getSnapshotSummaryFromDaysAgo(28, now, this.snapshotSummaries);
        var snapshot1w = this.snapshotSummaries[Math.max(0, this.snapshotSummaries.length - 2)];
        var snapshotNow = this.snapshotSummaries[this.snapshotSummaries.length - 1];

        this.changeValueAll = snapshotNow.value - snapshotFirst.value;
        this.changeValue1y = snapshotNow.value - snapshot1y.value;
        this.changeValue1m = snapshotNow.value - snapshot1m.value;
        this.changeValue1w = snapshotNow.value - snapshot1w.value;
    }
}